import { createContext, CSSProperties, FC, useContext, useEffect, useRef } from "react"
import { useWindowSize } from "./utils";

type IColorContext = {
    color: CSSProperties['backgroundColor'],
    setColor: (newColor: CSSProperties['backgroundColor']) => void
    rootRef?: React.RefObject<HTMLElement>
  }
  
export const ColorContext = createContext<IColorContext>({color: 'transparent', setColor: () => {}})

type ColorSectionProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
> & {
  background: CSSProperties["backgroundColor"];
};

export const ColorSection: FC<ColorSectionProps> = ({
  children,
  background,
  ...props
}) => {
  const { color, setColor } = useContext(ColorContext);
  const ref = useRef<HTMLElement>(null);
  const {width} = useWindowSize()
    const headerHeight = width && width > 770 ? 70 : 60;
  useEffect(() => {
      const onscroll =  () => {
      const rect = ref.current?.getBoundingClientRect();
      const top = rect?.top;
      const bottom = rect?.bottom;
      const height = rect?.height;
      // 
      if(top && height && bottom && top <= headerHeight && bottom > headerHeight && top > (-1 * height)){
        if(color !== background){
          setColor(background)
        }
      }
    };
    window.addEventListener('scroll', onscroll)
    return () => {window.removeEventListener('scroll', onscroll)}
  }, []);
  // if(isVisible) {

  //     setColor(background)
  //     
  //   }

  return (
    <section ref={ref} {...props}>
      {children}
    </section>
  );
};